import { ToastNotification } from '../../lib/interfaces/toastNotification';

export const state = {
  notifications: []
};

export const getters = {
  getNotification(state) {
    if (state.notifications) {
      return state.notifications[0];
    }
  }
};

export const mutations = {
  addNotification(state, toastNotification: ToastNotification): void {
    state.notifications.push(toastNotification);
  },

  removeNotification() {
    state.notifications.splice(0, 1);
  }
};
